import { registerRoute } from "../server";

/**
 * Minimal valid single-page blank PDF encoded as base64.
 * Used as the mock cover sheet PDF bytes for local testing.
 */
const MOCK_COVER_SHEET_PDF_BASE64 =
  "JVBERi0xLjAKMSAwIG9iajw8L1R5cGUgL0NhdGFsb2cgL1BhZ2VzIDIgMCBSPj5lbmRvYmoKMiAwIG9iajw8L1R5cGUgL1BhZ2VzIC9LaWRzIFszIDAgUl0gL0NvdW50IDE+PmVuZG9iagozIDAgb2JqPDwvVHlwZSAvUGFnZSAvUGFyZW50IDIgMCBSIC9NZWRpYUJveCBbMCAwIDYxMiA3OTJdPj5lbmRvYmoKeHJlZgowIDQKMDAwMDAwMDAwMCA2NTUzNSBmIAowMDAwMDAwMDA5IDAwMDAwIG4gCjAwMDAwMDAwNTggMDAwMDAgbiAKMDAwMDAwMDExNSAwMDAwMCBuIAp0cmFpbGVyPDwvU2l6ZSA0IC9Sb290IDEgMCBSPj4Kc3RhcnR4cmVmCjE5MAolJUVPRg==";

/**
 * Mock for POST /fax/coverSheetPreview
 *
 * Default response: coverSheetAvailable: true (with mock PDF bytes + token)
 *
 * To test coverSheetAvailable: false in the browser devtools console:
 *   window.mirageRouteConfigs["faxCoverSheetPreview"].coverSheetAvailable = false
 *
 * To test a failed request (blocks Send button):
 *   window.mirageRouteConfigs["faxCoverSheetPreview"].error = true
 *
 * To reset:
 *   window.mirageRouteConfigs["faxCoverSheetPreview"].coverSheetAvailable = true
 *   window.mirageRouteConfigs["faxCoverSheetPreview"].error = false
 */
export default function registerRoutes() {
  registerRoute({
    id: "faxCoverSheetPreview",
    route: "fax/coverSheetPreview",
    method: "post",
    routeConfig: {
      // @ts-ignore - custom field for toggling coverSheetAvailable in devtools
      coverSheetAvailable: true,
    },
    generateResponse: function (config) {
      // @ts-ignore
      if (config.coverSheetAvailable === false) {
        return { coverSheetAvailable: false };
      }
      return {
        coverSheetAvailable: true,
        coverSheetPdf: MOCK_COVER_SHEET_PDF_BASE64,
        coverSheetToken: "mock-cover-sheet-token-12345",
      };
    },
  });
}
